import { CURRENCY_MAP } from "../../pages/Utility/Constants";
import { getChargerById } from "../chargerAPI";
import { getRecentStatus } from "../statusAPI";

/**
 * Makes a call to get the chargers
 * @param {string} id - array of objects containing the chargers fields
 * @returns - returns status data for each charger
 */
export const loadChargersWithStatus = async (chargerIds, prevChargerStatus) => {
  let status = prevChargerStatus;
  try {
    const response = await Promise.all(chargerIds.map((item) => getChargerById(item)));
    const formatData = response?.map((chargerItem) => {
      const unitRate = `${CURRENCY_MAP[chargerItem?.currency] || ""} ${chargerItem?.perUnitRate || ""}`;
      // set up the chargerId along with the status
      // Add to prevChargerStatus
      status[chargerItem?.chargerId] = "Offline";
      return {
        _id:chargerItem?._id,
        chargerId: chargerItem?.chargerId,
        imageId: chargerItem?.imageId,
        name: chargerItem?.name,
        modelType: chargerItem?.modelType,
        connectors: chargerItem?.connectors,
        rating: chargerItem?.rating,
        firmwareVersion: chargerItem?.firmwareVersion,
        protocolType: chargerItem?.protocolType,
        vendorId: chargerItem?.vendorId,
        unitRate: unitRate,
        locationId: chargerItem?.locationId,
        status: "Offline",
      };
    });
    console.log("formatData:loadChargersWithStatus ", formatData);
    formatData?.length > 0 && formatData.sort((a, b) => a._id.localeCompare(b._id));
    //   await handleGetRecentStatus(formatData);
    return { formatData, status };
  } catch (err) {
    console.log("Error getting the chargersData: ", err.msg || err);
  }
};

/**
 * Makes a call to get the status
 * @param {Array} formattedChargerData - array of objects containing the chargers fields
 * @returns - returns status data for each charger
 */
export const loadChargerRecentStatus = async (formattedChargerData, prevChargerStatus) => {
  const previousStatus = prevChargerStatus;
  try {
    if (!formattedChargerData || formattedChargerData.length === 0) {
      console.log("No charger data available");
      return;
    }
    const response = await Promise.all(formattedChargerData.map((item) => getRecentStatus(item.chargerId)));
    let anyStatusChanged = false;
    console.log("formattedChargerData: ", response);

    const resRecentStatus = formattedChargerData?.map((charger) => {
      const matchingResponseItem = response?.find((item) => {
        const data = item?.data?.[0];
        return data?.chargerId === charger?.chargerId;
      });

      const data = matchingResponseItem?.data?.[0];

      if (data) {
        const newStatus = data.status;
        const chargerId = data.chargerId;

        const prevStatus = previousStatus?.[chargerId];
        const statusChanged = prevStatus !== newStatus;

        if (statusChanged) {
          anyStatusChanged = true;
          previousStatus[chargerId] = newStatus;
        }

        return { ...charger, status: newStatus };
      }
      return charger;
    });
    const recentStatusUpdate = resRecentStatus?.filter((item) => Object.keys(item)?.length > 0);

    recentStatusUpdate?.length > 0 && recentStatusUpdate.sort((a, b) => a._id.localeCompare(b._id));
    console.log(" anyStatusChanged, recentStatusUpdate, previousStatus: ", anyStatusChanged, recentStatusUpdate, previousStatus);
    
    return { anyStatusChanged, recentStatusUpdate, previousStatus };
  } catch (err) {
    console.log("Unexpected Error:", err);
    return err;
  }
};
